// extracted by mini-css-extract-plugin
export default {"profileHeader":"Xv3p5","profileHeaderImg":"DnuS1","profileHeaderInfo":"s6FRS","profileHeaderName":"H3qGx","profileHeaderEmail":"_Cy67","profileHeaderPhone":"TfeMN"};